import { useVariant } from "../context/VariantContext";

export default function About() {
  const { about } = useVariant();
  return (
    <section className="lp__about" id="about">
      {about.paragraphs.map((p, i) => (
        <p
          key={i}
          className={`lp__about-text${p.bold ? ' lp__about-text--bold' : ''}`}
        >
          {p.lines.map((line, j) => (
            <span key={j}>{j > 0 && <br />}{line}</span>
          ))}
        </p>
      ))}
      <div className="lp__about-photo">
        <img
          src={about.image}
          alt={about.imageAlt}
          loading="lazy"
        />
      </div>
    </section>
  );
}
